import script from "./NoticePopupDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticePopupDialog.vue?vue&type=script&setup=true&lang=js"

import "./NoticePopupDialog.vue?vue&type=style&index=0&id=78194a78&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78194a78"]])

export default __exports__